import { render, staticRenderFns } from "./ds-table.vue?vue&type=template&id=c4a87e10&scoped=true&"
import script from "./ds-table.vue?vue&type=script&lang=ts&"
export * from "./ds-table.vue?vue&type=script&lang=ts&"
import style0 from "./ds-table.vue?vue&type=style&index=0&id=c4a87e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a87e10",
  null
  
)

export default component.exports